import React, { useMemo } from 'react';
import { push } from 'connected-react-router';
import { connect } from 'react-redux';
import { AppState } from 'reducers/reducers';
import { selectedSpotInfo } from 'selectors';
import DashboardContent from 'components/Dashboard/DashboardContent/DashboardContent';
import AGSimpleSelect from 'components/AGSelect/AGSimpleSelect/AGSimpleSelect';
import Loader from 'components/Loader/Loader';
import Tenants from 'components/Tenants/Tenants';
import useFilters from 'hooks/useFilters';
import MonthYearUtil, { MonthYear, monthOptionsFromLaunchDate } from 'utils/monthYear';

type TenantsContainerProps = ReturnType<typeof mapStateToProps> & typeof mapDispatchToProps;

const TenantsContainer = ({ spot, push: connectedPush }: TenantsContainerProps) => {
    const options = useMemo(() => monthOptionsFromLaunchDate(spot?.launch_date), [spot?.launch_date]);
    const filterValidators = useMemo(
        () => ({
            monthYear(current: string | null): string {
                return options.some((option) => option.value === current)
                    ? (current as string)
                    : new MonthYearUtil().currentMonthYear.value;
            },
        }),
        [options]
    );

    const { filters, urlUpdater } = useFilters<{ monthYear: MonthYear['value'] }>({
        filterValidators,
        push: connectedPush,
    });

    const monthSelect = (
        <AGSimpleSelect
            selected={filters.monthYear}
            onSelect={urlUpdater.monthYear}
            options={options}
            placeholder="Month"
            maxHeight="300px"
        />
    );

    return (
        <DashboardContent title="Tenants" actionItem={monthSelect}>
            {spot ? <Tenants spot={spot} month={filters.monthYear} /> : <Loader />}
        </DashboardContent>
    );
};

function mapStateToProps(state: AppState) {
    return {
        spot: selectedSpotInfo(state),
    };
}

const mapDispatchToProps = {
    push,
};

export default connect(mapStateToProps, mapDispatchToProps)(TenantsContainer);
